import { alpha, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import FormTextField from '../../../../shared/FormTextField';

/** Same as Availability `sectionTitle` / unavailable dates labels. */
const policyFieldLabelSx = {
    color: 'text.secondary',
    fontWeight: 500,
    letterSpacing: 0.02,
} as const;

const PolicyDetails = ({
    isEditing,
    compactShell = false,
}: {
    isEditing: boolean;
    compactShell?: boolean;
}) => {
    const theme = useTheme();
    const { control } = useFormContext();

    const cancellationPolicy = useWatch({
        name: 'cancellationPolicy',
        control,
        defaultValue: '',
    });

    return (
        <Grid container columnSpacing='50px' rowSpacing='10px'>
            {!compactShell ? (
                <Grid item xs={12}>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: 'text.primary',
                            py: '30px',
                        }}
                    >
                        Terms and Conditions
                    </Typography>
                </Grid>
            ) : null}

            <Grid item xs={12}>
                <Typography
                    variant='body2'
                    color='text.secondary'
                    sx={{ mb: 2 }}
                >
                    Note: These terms will be displayed to the host and the
                    guest. The guest will be required to consent to these terms
                    before proceeding.
                </Typography>
            </Grid>

            <Grid container item xs={12} md={6}>
                <Grid item xs={12} lg={5}>
                    <Typography
                        variant='caption'
                        component='div'
                        sx={policyFieldLabelSx}
                    >
                        Cancellation Policy
                    </Typography>
                    {cancellationPolicy?.length < 500 ? (
                        <Typography color='primary' fontSize='10px'>
                            Characters left:{' '}
                            {500 - cancellationPolicy.length}{' '}
                        </Typography>
                    ) : cancellationPolicy?.length > 499 ? (
                        <Typography color='error' fontSize='12px'>
                            Max characters reached:{' '}
                            {cancellationPolicy.length - 500}
                        </Typography>
                    ) : null}
                </Grid>
                <Grid item xs={12} lg={7}>
                    <FormTextField
                        name='cancellationPolicy'
                        control={control}
                        inputProps={{ maxLength: 500 }}
                        multiline
                        rows={4}
                        disabled={!isEditing}
                        sx={{
                            bgcolor: !isEditing
                                ? alpha(theme.palette.custom.grey, 0.25)
                                : undefined,
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PolicyDetails;
